import { mergeSx } from "@/utils";

import { useFetchLogoContent } from "@/hooks/useFetchLogoContent";
import type { NestedLogoComponentProps } from "@/types";

import { SvgIcon } from "../SvgIcon";

export function ImmutableHorizontalLockup({
  sx,
  testId,
  ...props
}: NestedLogoComponentProps) {
  const svgContent = useFetchLogoContent("ImmutableHorizontalLockup");
  return (
    <SvgIcon
      {...props}
      testId={testId}
      viewBox="0 0 200 48"
      sx={mergeSx({ w: "200px", fill: "base.color.brand.1" }, sx)}
    >
      {svgContent && (
        <g
          data-testid={`${testId}__g`}
          dangerouslySetInnerHTML={{ __html: svgContent?.join?.("") }}
        />
      )}
    </SvgIcon>
  );
}
ImmutableHorizontalLockup.displayName = "ImmutableHorizontalLockup";
